import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const DISCIPLINES = [
  { id: "kickboxing", label: "Kickboxing / Muay Thaï" },
  { id: "boxe-anglaise", label: "Boxe anglaise" },
  { id: "bjj", label: "Jiu-Jitsu Brésilien" },
  { id: "jjj", label: "Jiu-Jitsu Can Ryu" },
  { id: "mma", label: "MMA" },
  { id: "karate", label: "Karaté" },
  { id: "savate", label: "Savate" },
  { id: "autre", label: "Autre" },
];

const INTERESTS = [
  { id: "gala_vi", label: "Invitation prioritaire Gala VI 2027" },
  { id: "stages", label: "Stages Plateforme Formation (Kru Ralph)" },
  { id: "collaboration", label: "Collaboration croisée entre clubs" },
  { id: "plateforme", label: "Accès anticipé à la Plateforme Formation en ligne" },
];

/**
 * Page Réseau Coachs Gladiateurs
 * URL : /plateforme/reseau-coachs
 * Cible : Head coachs visiteurs du Gala V (et futurs partenaires) — scannent le QR du Dossier Coach.
 */
export default function PlateformeReseauCoachs() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    club_name: "",
    city: "",
    province_country: "",
    disciplines: [],
    years_coaching: "",
    athletes_count: "",
    interested_in: [],
    notes: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Réseau Coachs Gladiateurs — Institut Impact Élite";
    const lp = document.createElement("link");
    lp.rel = "preconnect";
    lp.href = "https://fonts.googleapis.com";
    document.head.appendChild(lp);
    const lf = document.createElement("link");
    lf.rel = "stylesheet";
    lf.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Inter:wght@300;400;500;700&display=swap";
    document.head.appendChild(lf);
    return () => {
      document.head.removeChild(lp);
      document.head.removeChild(lf);
    };
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const toggleMulti = (field, value) => {
    setForm((prev) => {
      const current = prev[field];
      return {
        ...prev,
        [field]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const payload = {
        ...form,
        years_coaching: form.years_coaching ? parseInt(form.years_coaching, 10) : null,
        athletes_count: form.athletes_count ? parseInt(form.athletes_count, 10) : null,
      };
      await axios.post(`${BACKEND}/api/plateforme/reseau-coachs`, payload);
      setSubmitted(true);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          "Erreur — réessaie ou contacte-nous directement à impactkb.bjj@gmail.com"
      );
    } finally {
      setSubmitting(false);
    }
  };

  const baseStyle = {
    fontFamily: "Inter, system-ui, sans-serif",
    background: "#0d0d0d",
    color: "#f5f5f5",
    minHeight: "100vh",
  };

  return (
    <div style={baseStyle} data-testid="plateforme-reseau-coachs">
      <style>{`
        .editorial { font-family: 'Playfair Display', serif; }
        .label { letter-spacing: 0.4em; font-size: 11px; }
        .frame { border: 1px solid rgba(201, 169, 97, 0.25); }
        .divider-gold { background: linear-gradient(90deg, transparent, #C9A961 30%, #C9A961 70%, transparent); height: 1px; }
        .gold { color: #C9A961; }
        .red-c { color: #C8102E; }
        .bg-red-c { background: #C8102E; }
        .bg-gold { background: #C9A961; }
        .btn-primary { background: #C8102E; color: #fff; transition: 0.3s; border: none; cursor: pointer; }
        .btn-primary:hover { background: #fff; color: #C8102E; }
        .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
        .btn-secondary { color: #C9A961; border: 1px solid #C9A961; transition: 0.3s; background: transparent; }
        .btn-secondary:hover { background: #C9A961; color: #0d0d0d; }
        .pf-link { transition: color 0.2s; }
        .pf-link:hover { color: #C9A961; }
        .input-pf {
          background: #161616;
          border: 1px solid rgba(201, 169, 97, 0.25);
          color: #f5f5f5;
          padding: 14px 18px;
          width: 100%;
          font-family: 'Inter', sans-serif;
          font-size: 15px;
          transition: border 0.2s;
        }
        .input-pf:focus { border-color: #C9A961; outline: none; }
        .input-pf::placeholder { color: rgba(255, 255, 255, 0.3); }
        select.input-pf option { background: #161616; }
        .chip {
          display: inline-block; padding: 8px 14px; margin: 4px;
          border: 1px solid rgba(201, 169, 97, 0.4); color: #f5f5f5;
          cursor: pointer; font-size: 13px; transition: 0.2s;
          background: #161616;
        }
        .chip:hover { border-color: #C9A961; }
        .chip.active { background: #C9A961; color: #0d0d0d; border-color: #C9A961; font-weight: 600; }
      `}</style>

      {/* === NAV === */}
      <nav
        className="px-10 py-6 flex items-center justify-between"
        style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}
      >
        <Link to="/plateforme" className="flex items-center gap-4">
          <div className="relative">
            <div className="w-12 h-12 bg-red-c flex items-center justify-center">
              <span className="editorial text-white text-2xl font-black">I</span>
            </div>
            <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-gold"></div>
          </div>
          <div>
            <div className="label gold">— INSTITUT —</div>
            <div className="editorial text-2xl font-bold leading-none mt-0.5">Impact Élite</div>
          </div>
        </Link>
        <Link to="/plateforme" className="pf-link text-sm" data-testid="link-back">
          ← Retour
        </Link>
      </nav>

      <section className="grid md:grid-cols-12 min-h-[calc(100vh-90px)]">
        {/* LEFT narratif */}
        <div
          className="md:col-span-5 px-10 py-16 flex flex-col justify-center"
          style={{ background: "#161616" }}
        >
          <div className="label red-c mb-8">— RÉSEAU COACHS GLADIATEURS —</div>
          <h1
            className="editorial font-black text-5xl md:text-6xl leading-[0.95] mb-10"
            data-testid="reseau-title"
          >
            Le ring vous
            <br />
            <span className="italic gold">unit</span>.<br />
            Le réseau vous
            <br />
            <span className="italic gold">propulse</span>.
          </h1>
          <div className="divider-gold w-32 mb-8"></div>
          <p className="editorial italic text-xl text-white/80 mb-10 leading-relaxed">
            « Vous êtes les architectes silencieux des champions du Nord. Ce réseau, c'est notre façon de garder le contact entre éditions. »
          </p>
          <div className="space-y-4 text-sm text-white/75">
            <div className="flex gap-3">
              <span className="gold">◆</span>
              <span>Invitations prioritaires Gala VI 2027 (Val-d'Or · mai 2027)</span>
            </div>
            <div className="flex gap-3">
              <span className="gold">◆</span>
              <span>Accès anticipé aux stages Kru Ralph (Plateforme Formation)</span>
            </div>
            <div className="flex gap-3">
              <span className="gold">◆</span>
              <span>Opportunités de collaboration croisée entre clubs partenaires</span>
            </div>
            <div className="flex gap-3">
              <span className="gold">◆</span>
              <span>Aucun spam — communications utiles uniquement</span>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-white/10">
            <div className="label gold mb-3">— PRODUCTEUR FONDATEUR —</div>
            <div className="text-sm text-white/60">
              Kru Ralph D. Jean-Pierre · 25 ans en arts martiaux · 16 ans à Val-d'Or
            </div>
          </div>
        </div>

        {/* RIGHT formulaire */}
        <div className="md:col-span-7 px-10 py-16 flex flex-col justify-center">
          <div className="max-w-xl w-full">
            {!submitted ? (
              <>
                <div className="label red-c mb-6">— REJOINDRE LE RÉSEAU —</div>
                <h2 className="editorial font-black text-3xl md:text-4xl mb-3">
                  1 minute pour <span className="italic gold">rester connecté</span>.
                </h2>
                <p className="text-white/60 mb-10 text-sm">
                  Vos coordonnées restent confidentielles (Loi 25 · Québec).
                </p>

                <form onSubmit={handleSubmit} className="space-y-6" data-testid="reseau-form">
                  <div>
                    <label className="label gold block mb-2">— NOM COMPLET —</label>
                    <input
                      type="text"
                      name="full_name"
                      required
                      minLength={2}
                      value={form.full_name}
                      onChange={handleChange}
                      className="input-pf"
                      placeholder="Kru Pierre Tremblay"
                      data-testid="input-full-name"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="label gold block mb-2">— COURRIEL —</label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={form.email}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="coach@club.com"
                        data-testid="input-email"
                      />
                    </div>
                    <div>
                      <label className="label gold block mb-2">— TÉLÉPHONE (OPT.) —</label>
                      <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="514 555-1234"
                        data-testid="input-phone"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="label gold block mb-2">— NOM DU CLUB / ÉCOLE —</label>
                    <input
                      type="text"
                      name="club_name"
                      required
                      value={form.club_name}
                      onChange={handleChange}
                      className="input-pf"
                      placeholder="Crew Gym · GSC MMA · Top Karaté..."
                      data-testid="input-club"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="label gold block mb-2">— VILLE —</label>
                      <input
                        type="text"
                        name="city"
                        value={form.city}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="Montréal"
                        data-testid="input-city"
                      />
                    </div>
                    <div>
                      <label className="label gold block mb-2">— PROVINCE / PAYS —</label>
                      <input
                        type="text"
                        name="province_country"
                        value={form.province_country}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="Québec · Canada"
                        data-testid="input-province"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="label gold block mb-3">— DISCIPLINES ENSEIGNÉES —</label>
                    <div className="flex flex-wrap">
                      {DISCIPLINES.map((d) => (
                        <span
                          key={d.id}
                          onClick={() => toggleMulti("disciplines", d.id)}
                          className={`chip ${form.disciplines.includes(d.id) ? "active" : ""}`}
                          data-testid={`chip-discipline-${d.id}`}
                        >
                          {d.label}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="label gold block mb-2">— ANNÉES COACHING —</label>
                      <input
                        type="number"
                        name="years_coaching"
                        min={0}
                        max={80}
                        value={form.years_coaching}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="15"
                        data-testid="input-years"
                      />
                    </div>
                    <div>
                      <label className="label gold block mb-2">— ATHLÈTES ACTIFS —</label>
                      <input
                        type="number"
                        name="athletes_count"
                        min={0}
                        max={1000}
                        value={form.athletes_count}
                        onChange={handleChange}
                        className="input-pf"
                        placeholder="40"
                        data-testid="input-athletes"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="label gold block mb-3">— INTÉRÊTS —</label>
                    <div className="flex flex-wrap">
                      {INTERESTS.map((i) => (
                        <span
                          key={i.id}
                          onClick={() => toggleMulti("interested_in", i.id)}
                          className={`chip ${form.interested_in.includes(i.id) ? "active" : ""}`}
                          data-testid={`chip-interest-${i.id}`}
                        >
                          {i.label}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="label gold block mb-2">— NOTES (OPT.) —</label>
                    <textarea
                      name="notes"
                      rows={3}
                      value={form.notes}
                      onChange={handleChange}
                      className="input-pf"
                      placeholder="Ce que tu veux partager — événements à venir, projets, demandes..."
                      maxLength={1000}
                      data-testid="input-notes"
                    />
                  </div>

                  {error && (
                    <div
                      className="frame p-4 text-sm text-red-300"
                      style={{ background: "#3b0d0d", borderColor: "#C8102E" }}
                      data-testid="reseau-error"
                    >
                      ⚠️ {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={submitting}
                    className="btn-primary w-full py-4 font-bold tracking-[0.3em] text-xs"
                    data-testid="reseau-submit"
                  >
                    {submitting ? "ENVOI EN COURS..." : "REJOINDRE LE RÉSEAU →"}
                  </button>
                  <div className="text-[10px] text-white/30 tracking-widest text-center mt-4">
                    LOI 25 (QUÉBEC) · DONNÉES STOCKÉES AU CANADA · DÉSINSCRIPTION SUR DEMANDE
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center py-12" data-testid="reseau-success">
                <div className="text-7xl mb-8">🥊</div>
                <div className="label gold mb-4">— BIENVENUE DANS LE RÉSEAU —</div>
                <h2 className="editorial font-black text-4xl md:text-5xl mb-6">
                  Vous êtes
                  <br />
                  <span className="italic gold">officiellement</span> dedans.
                </h2>
                <p className="text-white/70 max-w-md mx-auto mb-10 leading-relaxed">
                  Merci {form.full_name.split(" ")[0]}. Kru Ralph reviendra vers vous personnellement
                  avant le Gala VI 2027. À très bientôt sur le ring ou en stage.
                </p>
                <div className="divider-gold w-32 mx-auto mb-10"></div>
                <div className="flex flex-wrap justify-center gap-3">
                  <Link
                    to="/plateforme/fondateur"
                    className="btn-secondary px-6 py-3 text-xs tracking-[0.2em]"
                    data-testid="link-fondateur"
                  >
                    LE FONDATEUR
                  </Link>
                  <Link
                    to="/plateforme/disciplines/kickboxing"
                    className="btn-secondary px-6 py-3 text-xs tracking-[0.2em]"
                    data-testid="link-disciplines"
                  >
                    LES DISCIPLINES
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <footer className="px-10 py-12" style={{ borderTop: "1px solid rgba(201,169,97,0.2)" }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="editorial font-black text-2xl mb-2">Institut Impact Élite</div>
          <div className="text-sm text-white/60 mb-6">
            Val-d'Or, Québec, Canada · impactkb.bjj@gmail.com
          </div>
          <div className="divider-gold w-32 mx-auto mb-4"></div>
          <div className="text-xs text-white/40 tracking-widest">
            © 2026 — RÉSEAU COACHS GLADIATEURS · GALA V
          </div>
        </div>
      </footer>
    </div>
  );
}
